export var withNamespace = function withNamespace(obj, NAMESPACE) {
  return Object.assign({}, obj, {
    NAMESPACE: NAMESPACE,
    ns: function ns() {
      return this[this.NAMESPACE] || {};
    }
  });
};